<template>
  <el-dialog
    title="添加用户"
    :visible.sync="dialogVisible"
    top="29vh"
    width="500px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="105px"
      >
        <el-form-item label="用户账户" prop="account">
          <el-input
            v-model="form.account"
            placeholder="请输入用户账号"
            maxlength="20"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phoneNumber">
          <el-input
            v-model="form.phoneNumber"
            placeholder="请输入手机号码"
            maxlength="11"
            clearable
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="绑定姓名" prop="userName">
          <el-input
            v-model="form.userName"
            placeholder="请输入绑定姓名"
            maxlength="10"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item label="初始密码" prop="secret">
          <el-radio-group v-model="isDefaultPWD" @change="changePWD">
            <el-radio :label="true">默认密码</el-radio>
            <el-radio :label="false">自定义密码</el-radio>
          </el-radio-group>
          <template v-if="!isDefaultPWD">
            <el-input
              v-model="form.secret"
              show-password
              placeholder="请输入初始密码"
              maxlength="32"
            ></el-input>
          </template>
          <template v-else>
            <el-alert
              style="line-height: normal"
              title="默认密码为 123456 "
              :closable="false"
              type="success"
            >
            </el-alert>
          </template>
        </el-form-item>
      </el-form>
      <div class="fn-text-center">
        <el-button type="primary" @click="handleCreate('ruleForm')"
          >确定</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import CheckObj from "@/utils/check.js";
export default {
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    const defaultPWD = "123456";
    return {
      dialogVisible: true,
      defaultPWD,
      isDefaultPWD: true,
      form: {
        account: "",
        phoneNumber: "",
        userName: "",
        secret: defaultPWD
      },
      rules: {
        account: [
          isEmpty("请输入用户账号"),
          {
            validator: (rule, value, callback) => {
              if (!/\w{6,20}/.test(value)) {
                return callback(
                  new Error("请输入6~20位数字、字母、“_”组成的账号")
                );
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        phoneNumber: [
          isEmpty("请输入手机号码"),
          {
            validator: (rule, value, callback) => {
              if (
                value &&
                !CheckObj.checkPhone(value) &&
                !CheckObj.checkTelephone(value)
              ) {
                return callback(new Error("请输入正确的手机号码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        userName: [
          isEmpty("请输入绑定姓名"),
          {
            validator: (rule, value, callback) => {
              if (value && !CheckObj.checkChineseName(value)) {
                return callback(new Error("请输入正确的中文姓名"));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        secret: [
          isEmpty("请输入初始密码"),
          {
            validator: (rule, value, callback) => {
              // 校验长度
              if (!/.{6,32}/.test(value)) {
                return callback(new Error("请输入长度为6~32的密码"));
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      isLoading: false
    };
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 改变默认密码
    changePWD(bool) {
      this.form.secret = bool ? this.defaultPWD : "";
      // 移除表单项的校验结果
      if (bool) {
        this.$refs.ruleForm.clearValidate("secret");
      }
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      const { ...others } = this.form;
      return {
        ...others
      };
    },
    handleCreate(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadCreateUser();
        }
      });
    },
    loadCreateUser() {
      this.isLoading = true;
      this.$api("user", "createUser", {
        ...this.processDataSubmit()
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
